document.addEventListener('DOMContentLoaded', function() {
    // 查找当前区块的轮播元素
    const imageSwitcherContainers = document.querySelectorAll('.image-switcher-1125-container');
    
    imageSwitcherContainers.forEach(container => {
        const slides = container.querySelector('.image-switcher-1125-slides');
        const slideItems = container.querySelectorAll('.image-switcher-1125-slide');
        const prevBtn = container.querySelector('.image-switcher-1125-prev');
        const nextBtn = container.querySelector('.image-switcher-1125-next');
        
        if (!slides || slideItems.length === 0) return;
        
        let currentIndex = 0;
        const totalSlides = slideItems.length;
        
        // 从 data 属性获取配置
        const autoplayEnabled = container.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
        
        // 更新幻灯片位置
        function updateSlidePosition() {
            slides.style.transform = `translateX(-${currentIndex * 100}%)`;
        }
        
        // 下一张幻灯片
        function nextSlide() {
            currentIndex = (currentIndex + 1) % totalSlides;
            updateSlidePosition();
        }
        
        // 上一张幻灯片
        function prevSlide() {
            currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
            updateSlidePosition();
        }
        
        // 添加按钮事件监听
        if (nextBtn) nextBtn.addEventListener('click', nextSlide);
        if (prevBtn) prevBtn.addEventListener('click', prevSlide);
        
        let autoplayInterval = null;
        
        // 自动播放设置
        if (autoplayEnabled && autoplaySpeed > 0 && totalSlides > 1) {
            autoplayInterval = setInterval(nextSlide, autoplaySpeed);
            
            // 鼠标悬停时暂停自动播放
            container.addEventListener('mouseenter', () => {
                if (autoplayInterval) {
                    clearInterval(autoplayInterval);
                    autoplayInterval = null;
                }
            });
            
            container.addEventListener('mouseleave', () => {
                if (!autoplayInterval && totalSlides > 1) {
                    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
                }
            });
        }
        
        // 键盘导航
        container.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                prevSlide();
            } else if (e.key === 'ArrowRight') {
                nextSlide();
            }
        });
        
        // 触摸滑动支持
        let startX = 0;
        let endX = 0;
        
        container.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });
        
        container.addEventListener('touchend', (e) => {
            endX = e.changedTouches[0].clientX;
            handleSwipe();
        });
        
        function handleSwipe() {
            const swipeThreshold = 50;
            const diff = startX - endX;
            
            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    nextSlide(); // 向左滑动
                } else {
                    prevSlide(); // 向右滑动
                }
            }
        }
    });
});